// extracted by mini-css-extract-plugin
module.exports = {"promocaoRow":"promocao-marca-propria_promocaoRow__1TmDE"};